export enum PasswordValidationColor {
  low = '#FF6565',
  middle = '#FFB400',
  strong_middle = '#6CE9A6',
  strong = '#1EB099'
}
